var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasycredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 264.375,
    height: 79.139,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M23.375 31.884v-7.793l23.374-8.506v7.791Z",
    fill: "#4a545d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7",
    d: "M23.375 16.299V8.506L46.749 0v7.791Z",
    fill: "#4a545d"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M0 63.767v-7.792l23.375-8.507v7.792Z",
    fill: "#c41a29"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "M0 48.183v-7.792l23.375-8.508v7.793Z",
    fill: "#c41a29"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M0 32.599v-7.792l23.375-8.506v7.791Z",
    fill: "#c41a29"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "m124.723 70.356-8.816-15.094h8.749l4.006 7.68 4.041-7.68h8.649l-8.816 14.992v8.382h-7.813ZM94.468 75.13l4.173-4.975a13.4 13.4 0 0 0 8.182 2.738c1.4 0 2-.368 2-1v-.073c0-.667-.735-1.035-3.238-1.536-5.243-1.068-9.851-2.57-9.851-7.513v-.067c0-4.442 3.473-7.881 9.918-7.881 4.507 0 7.847 1.069 10.552 3.206l-3.808 5.277a12.249 12.249 0 0 0-7.012-2.3c-1.168 0-1.7.4-1.7.969v.068c0 .634.635 1.035 3.107 1.5 5.977 1.1 9.984 2.838 9.984 7.546v.068c0 4.908-4.041 7.913-10.319 7.913-4.741 0-9.016-1.336-11.987-3.94m-11.054-5.175-2.137-5.676-2.137 5.676Zm-5.944-14.86h7.747l9.851 23.542h-8.482l-1.235-3.139h-8.181l-1.2 3.139h-8.348Zm-30.722.168h19.936v6.411H54.429v2.371h11.42v5.643h-11.42v2.532h12.423v6.412h-20.1Z",
    fill: "#c41a29"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12",
    d: "M249.682 61.873h-6.879v-6.612h21.572v6.611h-6.879v16.764h-7.815Zm-16.23-6.612h7.818v23.375h-7.813Zm-15.327 16.563c3.573 0 5.878-1.468 5.878-4.841v-.068c0-3.372-2.3-4.841-5.878-4.841h-1.3v9.751Zm-9.116-16.563h8.95c9.282 0 13.924 4.574 13.924 11.487v.067c0 6.913-4.742 11.822-14.191 11.822h-8.683Zm-21.572 0h19.933v6.412h-12.253v2.37h11.421v5.643h-11.421v2.538h12.423v6.412h-20.1Zm-12.724 11.12c1.871 0 3.005-.835 3.005-2.272v-.067c0-1.5-1.168-2.238-2.971-2.238h-3.406v4.576Zm-11.186-11.12h11.42c4.14 0 6.779 1.035 8.415 2.672a7.339 7.339 0 0 1 2.137 5.543v.066a7.563 7.563 0 0 1-4.608 7.147l5.443 7.948h-8.917l-4.407-6.679h-1.67v6.679h-7.815Zm-24.378 11.754v-.067a12.08 12.08 0 0 1 12.421-12.187 11.459 11.459 0 0 1 10.584 6.078l-6.444 3.774a4.541 4.541 0 0 0-4.242-2.838c-2.637 0-4.375 2.3-4.375 5.108v.066c0 3.039 1.8 5.177 4.375 5.177 2.2 0 3.439-1.2 4.408-2.939l6.445 3.64a12.384 12.384 0 0 1-23.176-5.81",
    fill: "#4a545d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasycredit);
export default __webpack_public_path__ + "static/media/easycredit.d8ac91caaa1872465dc5773d1827411f.svg";
export { ForwardRef as ReactComponent };